import axios from "axios";
import { useState } from "react";
import "./Common.scss";

const CompanyUploadModal = ({
  closeModal,
  modalTitle,
  content1,
  content2,
  userId,
}) => {
  const [companyFile, setCompanyFile] = useState(""); // 사업자 등록증

  const onUploadSubmit = async (e) => {
    e.preventDefault();
    setCompanyFile(e.target.files);
  };

  if (companyFile) {
    const uploadFile = companyFile[0];
    // console.log(uploadFile);
    const formData = new FormData();
    formData.append("files", uploadFile);
    formData.append("docs", JSON.stringify({ comment: "사업자등록증" }));

    axios({
      headers: {
        "Content-Type": "multipart/form-data",
      },
      method: "post",
      url: `/api/applicant/${userId}/doc`,
      data: formData,
    })
      .then((response) => {
        // console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
        alert("파일 업로드 실패");
        console.log(error);
      });
  }

  return (
    <div className="popup_bg_bbs " onClick={closeModal}>
      <div className="password_change " onClick={(e) => e.stopPropagation()}>
        <div className="pophead_bbs">
          <h1>{modalTitle}</h1>
        </div>
        <div className="password_change_inner">
          <div
            className="input_wrap file_input_wrap"
            style={{ backgroundColor: "white", height: "40px" }}
          >
            <input
              className="input_box file_input"
              type="file"
              id="file"
              style={{ visibility: "hidden", width: "150px" }}
              onChange={onUploadSubmit}
            />
            <label
              htmlFor="file"
              className="file_label"
              style={{ height: "100%" }}
            >
              {content1}
            </label>
            {companyFile[0]?.name === undefined ? (
              <h5 style={{ width: "100%" }}>파일을 선택해주세요</h5>
            ) : (
              <h5 style={{ width: "100%" }}>{companyFile[0]?.name}</h5>
            )}
          </div>
          <div className="btns_wrap">
            <button className="btn_confirm" type="button">
              <a
                href={`/api/applicant/${userId}/doc`}
                style={{ color: "white" }}
                download
              >
                {content2}
              </a>
            </button>
          </div>
          <div className="btns_wrap">
            <button className="btn_color" onClick={closeModal}>
              <span className="material-icons">취소</span>
            </button>
            <button className="btn_confirm" onClick={closeModal}>
              <span className="material-icons">확인</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CompanyUploadModal;
